


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";

@Component({
  name: "fillInTable",
})
export default class fillInTable extends Vue {
  private newArr: Array<string> = [];
  private zItem!: any;
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) showScore!: boolean;
  @Prop({ type: String, default: "" }) businessType!: string;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    this.compuedColumn();
  }
  tableData = [];
  columns = [];

  compuedColumn() {
    let rowData = this.item.jsonConfig.rowList || [];
    let columnData = this.item.jsonConfig.columnList || [];
    let computedColumnData: any = [
      {
        field: "fieldZero",
        key: "fieldZero",
        label: this.item.jsonConfig.crossCellText || "",
        align: "center",
        width: 100,
        fixed: "left",
      },
    ];
    columnData.forEach((col: any, index: number) => {
      let column = {
        field: "field" + index,
        key: "field" + index,
        label: col.content,
        align: "left",
        width: 130,
        fixed: "",
      };

      computedColumnData.push(column);
    });
    // console.log("computedColumnData", columnData, computedColumnData);
    // console.log("rowData", rowData);
    let computedTableData: any = [];
    for (let index = 0; index < rowData.length; index++) {
      let data: any = {};

      for (const item of computedColumnData) {
        if (this.viewMode == "ANSWERREVIEW" && this.item.answer) {
          data[item.field] = this.item.answer[index][item.field];
        } else {
          data[item.field] = "";
        }
      }
      data.fieldZero = rowData[index].content;
      computedTableData.push(data);
    }
    // console.log("computedTableData", computedTableData);

    this.tableData = computedTableData;
    this.columns = computedColumnData;
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
}
